import { OverlayRef } from '@angular/cdk/overlay';
import { Observable } from 'rxjs';

export class AuthOverlayRef {
  public dismissed?: boolean | null = null;
  public credentials?: string | null = null;

  constructor(private readonly overlayRef: OverlayRef) {
    this.dismissed = false;
  }

  public close(): void {
    this.overlayRef.dispose();
  }

  public afterClosed(): Observable<any> {
    return this.overlayRef.detachments();
  }
}
